<template>
    <div class="examAllClass" style="width:100%;">
        <!-- 超时处理 -->
        <el-dialog
            :visible.sync="dialogTimeTo"
            width="30%"
            :close-on-click-modal="false"
            :show-close="false"
            :close-on-press-escape="false"
            :class="['dialogTimeToClass',upList.length>0? 'yesList':'']"
            center
            :before-close="handleClose"
            >
            <div class="scratching">
                <div class="scratching_img" :style="{marginTop:(noUplistStatus? '20px':'')}"></div>
                <div class="scratching_text" v-if="!noUplistStatus" v-html="msgTitle"></div>
                <div class="scratching_text" v-else :style="{marginTop:(upList.length<=0? '30px':'')}">当前填报已结束,系统将在<b style="color:red;">{{numTime}}</b>秒后自动提交填报结果'</div>
            </div>
            <div class="upLoadFile" :style="{maxHeight:`${tableHeight}px`}">
                <div v-for="(item,index) in upList" :key="index" class="upLoadFile_li">
                    <span class="upLoadFile_span">{{item.serial}}</span>
                    <el-progress :text-inside="true" :percentage="Number(`${item.percentage<0? 0:item.percentage>100? 100:item.percentage}`)" :color="customColorMethod" :stroke-width="20" class="upLoadFile_progress"></el-progress>
                    <el-button type="primary" v-if="item.error" @click="uloadAgain(item)" size="mini" class="upLoadFile_twoBtu">重传</el-button>
                </div>
            </div>
            <p class="okUpData" v-show="successStatus">上传成功<b style="color:red;">{{numTime}}</b>秒后自动提交填报结果</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="timeTo" :disabled="disabledStatus" :style="{background:(disabledStatus? '#c0c4cc':'')}" class="closeBtu"> 提交填报 </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import utils from '../../lib/util'
import oss from '../../lib/oss'
export default {
    name:'examAllOk',
    data() {
        return {
            dialogTimeTo:false,
            msgTitle:'当前填报已结束，系统监测到有文件正在上传中，<b style="color:red;">请勿关闭和刷新本页面</b>，上传结束后将自动提交试卷。',
            tableHeight:'300',
            jsonData:[],
            jsonDataJudge:[],
            upList:[],
            successStatus:false,
            successList:[],
            numTime:10,
            threeTime:null,
            noUplistStatus:false,
            disabledStatus:true,//控制手动提交

            sucList:[],
            maxNumber:0,//记录最大值
        }
    },
    watch:{
        'successStatus':function(now,old){
            if(now){
                this.disabledStatus = false
                this.countdown10()
            }
        },
        'noUplistStatus':function(now,old){
            if(now){
                this.disabledStatus = false
                this.countdown10()
            }
        },
        "$store.state.isZip":{
            deep: true,
            handler(val){
                if(this.dialogTimeTo){
                    this.processTheData(val.zipLoading)
                }
            }
        },
    },
    created(){},
    beforeDestroy() {
        this.threeTime && window.clearInterval(this.threeTime)
    },
    mounted(){
        this.$nextTick(()=>{
            this.conHeightFun()
        })
        window.addEventListener('resize', () => this.conHeightFun(), false)
    },
    methods:{
        conHeightFun(){
            var scrollBoxH = document.getElementsByClassName('examAllClass')[0]
            var hg = window.getComputedStyle(scrollBoxH).height
            this.tableHeight=Number(hg.substring(0,hg.length-2)-600);
        },
        processTheData(ing){
            let that = this
            that.upList = []
            for (let i = 0; i < that.jsonDataJudge.length; i++) {
                if(that.jsonDataJudge[i] == '120'){
                    let docArr = that.upingIndexList(ing,i+1)
                    for (let xi = 0; xi < docArr.length; xi++) {
                        if( eval("ing.doc_"+docArr[xi].replace(/doc_/g,''))){
                            if(eval("ing.doc_"+docArr[xi].replace(/doc_/g,''))>=100){//上传完成记录
                                if(that.sucList.length>0){
                                    let zimuth = false
                                    for (const elem of that.sucList) {
                                        if(elem.uuid == docArr[xi]) zimuth = true
                                    }
                                    if(!zimuth){
                                        that.sucList.push({
                                            serial:`第${utils.intToChinese(i+1)}题`,
                                            percentage:100,
                                            index:i+1,
                                            uuid:docArr[xi],
                                            error:false,
                                        }) 
                                    }
                                }else{
                                    that.sucList.push({
                                        serial:`第${utils.intToChinese(i+1)}题`,
                                        percentage:100,
                                        index:i+1,
                                        uuid:docArr[xi],
                                        error:false,
                                    })
                                }
                            }else{
                                that.upList.push({
                                    serial:`第${utils.intToChinese(i+1)}题`,
                                    percentage:eval("ing.doc_"+docArr[xi].replace(/doc_/g,'')),
                                    index:i+1,
                                    uuid:docArr[xi],
                                    error:false,
                                })
                            }
                        }
                    }
                }
            }
            that.upList = that.upList.concat(that.sucList);
            that.upList.sort((a,b)=>{ return a.index-b.index})
            //全部传完
            if(that.sucList.length == that.maxNumber){
                this.successStatus = true
                this.disabledStatus = false
            }
        },
        open(jsonData,jsonDataJudge,flages){
            let that = this;
            that.upList = []
            that.sucList = []
            that.jsonDataJudge = utils.deepClone2(jsonDataJudge)
            that.jsonData = utils.deepClone2(jsonData)
            that.maxNumber = Object.keys(that.$store.getters.is_isZip_zipLoading).length
            if(that.maxNumber<=0) that.noUplistStatus = true
            else that.processTheData(that.$store.getters.is_isZip_zipLoading)
            that.dialogTimeTo = true
        },
        // 重传
        uloadAgain(item){
            let that = this
            if(!item) return
            oss.reUploadFile(item.index,function(e,file){
                if(e){
                    that.jsonData[item.index-1].designUrl = e
                }
            })
        },
        // 开启十秒倒计时
        countdown10(){
            let that = this
            that.threeTime = window.setInterval(function () {
                that.numTime--;
                if(that.numTime<=0){
                    window.clearInterval(that.threeTime)
                    that.timeTo()//自动提交考试结果
                }
            },1000)
        },
        customColorMethod(percentage) {
            if (percentage < 30) {
                    return '#e6a23c';
                } else if (percentage < 70) {
                    return '#409eff';
            } else {
                return '#67c23a';
            }
        },
        handleClose(done){
            this.upList = []
            this.successList = []
            this.jsonData = []
            this.successStatus = false
            this.noUplistStatus = false
            this.dialogTimeTo = false
            done();
        },
        timeTo(){
            this.$emit('autoSubmit',[])
            this.threeTime && window.clearInterval(this.threeTime)
            this.dialogTimeTo = false
        },
        sortData(a, b) {
            return a.serial - b.serial
        },
        upingIndexList(obj,num){
            if(JSON.stringify(obj)=='{}') return []
            return Object.keys(utils.deepClone2(obj)).filter((item)=>item.indexOf(`doc_${num}_`)>=0)
        }
    }
}
</script>
<style scoped lang="less">
    .examAllClass{
        width: 100%;
    }
    .titleTap{
        font-size: 18px;
        font-weight: bold;
        box-sizing: border-box;
        padding: 30px 15px 0 15px;
        text-align: center;
    }
    .dialogTimeToClass{
        .scratching{
            height: 70%;
            width: 100%;
            margin: auto;
            box-sizing: border-box;
            padding: 5px 0%;
            .scratching_img{
                width: 90%;
                height: 150px;
                background-image: url('../../../static/images/timeoutimg.png');
                background-size: auto 90%;
                background-position: 50% 0;
                background-repeat: no-repeat;
                margin: auto;
            }
            .scratching_text{
                width: 82%;
                margin: auto;
                font-size: 18px;
                font-weight: normal;
                text-align: center;
                font-weight: bold;
            }
        }
        .upLoadFile{
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            margin-top: 10px;
            .upLoadFile_li{
                width: 100%;
                margin: 5px 0;
                .upLoadFile_span{
                    float: left;
                    width: 15%;
                    display: inline-block;
                    text-align: center;
                }
                .upLoadFile_progress{
                    float:left;
                    width: 70%;
                    display: inline-block;
                }
                .upLoadFile_twoBtu{
                    float:right;
                    width: 14%;
                    display: inline-block;
                    padding: 5px 15px !important;
                    margin-top: -2px;
                }
            }
            .upLoadFile_li::after{
                content: '';
                height: 0;
                display: block;
                overflow: hidden;
                clear: both;
            }
        }
        .okUpData{
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            margin-top: 10px;
        }
        .closeBtu{
            width: 75%;
            background-color: #004BB4;
            border: none !important;
            color: #fff;
            font-size: 18px;
            padding: 9px 0;
        }
    }
    .yesList{
        .scratching_img{
            margin-top: 20px;
        }
        .scratching_text{
            margin: 29px auto;
        }
    }
</style>
<style>
    .dialogTimeTo .el-dialog{
        width: 600px !important;
    }
    .dialogTimeTo .el-dialog__body {
        padding: 10px 15px !important;
    }
    .dialogTimeToClass .el-dialog{
        width: 350px !important;
        min-height: 450px;
    }
    .yesList .el-dialog{
        width: 450px !important;
    }
    .dialogTimeToClass .el-dialog .el-dialog__body{
        height: 64%;
        padding-bottom: 15px !important;
    }
    .dialogTimeToClass .el-dialog .el-dialog__header{
        display: none;
    }
    .dialogTimeToClass .el-dialog .el-dialog__footer{
        padding-bottom: 25px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam2/examTimeTo.vue